import { createSelector } from '@ngrx/store';
import { currentLocationState } from '../root';

export const isCurrentLocationValidating = createSelector(currentLocationState, (currentLocation) =>
    currentLocation.validation ? currentLocation.validation.isValidating : false,
);
